<template>
    <b-overlay :show="busy" rounded="sm">
        <b-card class="standardpage tiles">
            <b-card-header>
                <i :class="icon" class="mr-1"></i>
                {{ title }}
                <div class="card-header-actions">
                    <b-button size="sm" variant="outline-primary" class="card-header-action mr-1" @click="layout_refresh()"
                        :disabled="layout_edit">
                        <i class="fa fa-refresh"></i>
                    </b-button>

                    <b-button size="sm" variant="outline-primary" class="card-header-action mr-1"
                        :to="'/cmsedit?container=' + this.$options.name" :disabled="layout_edit">
                        <i class="fa fa-pencil"></i>
                    </b-button>

                    <b-button size="sm" variant="outline-primary" class="card-header-action" :disabled="layout_edit"
                        v-b-toggle.addtile>
                        <i class="fa fa-plus-square"></i>
                    </b-button>
                </div>
            </b-card-header>

            <b-card-body class="px-0">
                <b-row class="px-3">
                    <b-col>
                        <div id="refresh">
                            <div v-if="window.width > 768">
                                <span class="mr-2">Auto refresh:</span>
                                <b-button v-if="refresh_at > 0" id="refresh_popover-id" size="sm" variant="outline-primary"
                                    ref="button" style="width: 100px">{{ refresh_at }} minute(s)</b-button>
                                <b-button v-if="refresh_at == 0" id="refresh_popover-id" size="sm" variant="outline-primary"
                                    ref="button" class="ml-2" style="width: 100px">Off</b-button>
                            </div>
                            <div v-else>
                                <b-row>
                                    <b-col cols="12" md="6">Auto refresh:</b-col>
                                    <b-col>
                                        <b-button v-if="refresh_at > 0" id="refresh_popover-id" size="sm"
                                            variant="outline-primary" ref="button" style="width: 100px">{{ refresh_at }}
                                            minute(s)</b-button>
                                        <b-button v-if="refresh_at == 0" id="refresh_popover-id" size="sm"
                                            variant="outline-primary" ref="button" class="ml-2"
                                            style="width: 100px">Off</b-button>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                        <b-popover target="refresh_popover-id" :show.sync="refresh_popover" triggers="click"
                            placement="bottom" container="refresh" ref="popover">
                            <div>
                                <b-form-radio-group class="mt-2 mb-2" name="Auto Refresh Every" v-model="refresh_at"
                                    :options="[
                                        { text: 'Off', value: 0 },
                                        { text: '1 min', value: 1 },
                                        { text: '5 min', value: 5 },
                                        { text: '10 min', value: 10 },
                                    ]" stacked></b-form-radio-group>

                                <b-button @click="refresh_popover = false" size="sm" variant="outline-primary"
                                    class="ml-2">OK</b-button>
                            </div>
                        </b-popover>
                    </b-col>
                    <b-col align-self="end" class="text-right">
                        <div v-if="window.width > 768">
                            <span class="mr-2">Last updated:</span>
                            <span class="text-primary">{{ refresh_timeago }}</span>
                        </div>
                        <div v-else>
                            <b-row>
                                <b-col class="text-right" cols="12" md="6">Last updated:</b-col>
                                <b-col>
                                    <span class="text-primary">{{ refresh_timeago }}</span>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="px-3 mt-4">
                    <b-button-group class="ml-3">
                        <b-row no-gutters>
                            <b-col cols="auto">
                                <b-button squared size="sm" :title="title + ' tiles'" :variant="toolbar_variant"
                                    :pressed="selectedComponent == null" @click="selectedComponent = null"><i
                                        class="fa fa-home pr-3"></i>Home</b-button></b-col>
                            <b-col cols="auto">
                                <b-button squared size="sm" :variant="toolbar_variant"
                                    :pressed="selectedComponent == 'BCorp'" @click="selectedComponent = 'BCorp'">
                                    <i class="fa fa-envira pr-3"></i>B Corp
                                </b-button></b-col>
                            <b-col cols="auto">
                                <b-button squared size="sm" :variant="toolbar_variant"
                                    :pressed="selectedComponent == 'TPSolar'" @click="selectedComponent = 'TPSolar'">
                                    <i class="fa fa-certificate pr-3"></i>TP Solar
                                </b-button></b-col>

                            <b-col cols="auto" v-if="permissionvalid('carbonemissions.view')">
                                <b-button squared size="sm" :variant="toolbar_variant"
                                    :pressed="selectedComponent == 'CarbonEmissions'"
                                    @click="selectedComponent = 'CarbonEmissions'">
                                    <i class="fa fa-globe pr-3"></i>TP Emissions
                                </b-button></b-col>

                        </b-row>
                    </b-button-group>
                </b-row>
                <div v-if="selectedComponent == null" class="dashboard_layout mt-4 ml-3">
                    <b-row no-gutters :style="layout_edit ? 'background-color:rgba(225, 225, 225, 0.1)' : ''
                        ">
                        <b-col :cols="item.cols" :md="item.md" :lg="item.lg" v-for="(item, index) in layout_grid"
                            :key="index" no-body class="pr-3">
                            <b-card class="ml-0" no-body :border-variant="tile_selected == index ? 'secondary' : null"
                                style="border-radius: 0" @mouseover="!tile_settings ? (tile_selected = index) : null">
                                <div class="popover-actions" :id="'actions-container-' + index.toString()">
                                    <b-button v-show="tile_selected == index" variant="link" size="sm" title="Actions"
                                        squared :id="'popover-target-' + index.toString()" class="float-right p-0">
                                        <i class="fa fa-ellipsis-h text-primary"></i>
                                    </b-button>
                                </div>
                                <b-popover :container="'actions-container-' + index.toString()"
                                    :target="'popover-target-' + index.toString()" triggers="hover" placement="leftbottom">
                                    <div>
                                        <b-nav vertical>
                                            <section v-for="(action, index) in defaultOptions.layout_grid[
                                                index
                                            ].options.actions" :key="index">
                                                <b-nav-item v-if="!action.divider" :title="action.label"
                                                    @click.stop="invoke_action(action, index)">
                                                    <b-row class="px-2">
                                                        <b-col class="px-0">
                                                            <span class="text-normal">{{
                                                                action.label
                                                            }}</span>
                                                        </b-col>
                                                        <b-col cols="1">
                                                            <i :class="action.icon" class="text-primary"></i>
                                                        </b-col>
                                                    </b-row>
                                                </b-nav-item>
                                                <div class="divider" v-if="action.divider"></div>
                                            </section>
                                        </b-nav>
                                    </div>
                                </b-popover>
                                <component :is="item.name" :tile="item" :refresh="refresh" @refreshed="refresh = false">
                                </component>
                            </b-card>
                        </b-col>
                    </b-row>
                </div>
                <div class="px-3 mt-3">
                    <component :is="selectedComponent" :search="search" />
                </div>

             

                <div class="px-3 mt-3 cms_content" v-if="content.length > 0 && !selectedComponent">
                    <b-card-group columns>
                        <div v-for="card in content[0].elements.filter(o => o.type == 'b-card')" :key="card.id"
                            v-html="card.data" class="m-4" />

                    </b-card-group>
                </div>
            </b-card-body>

            <!-- <div class="cms_content">
                <b-card-group columns>

                    <b-card bg-variant="primary" text-variant="white" class="round-50 text-center p-4">
                        <b-title><i class="fa-3x fa fa-laptop"></i></b-title>

                        <blockquote class="blockquote mb-0 mt-2">
                            <p>25/100 TravelPlaces staff are <cite title="Source Title">carbon Literacy trained</cite>
                            </p>

                        </blockquote>
                    </b-card>

                    <b-card bg-variant="info" text-variant="white" class="text-center p-4">
                        <b-title><i class="fa-3x fa fa-code"></i></b-title>
                        <b-card-text class="mt-2">
                            Link to Bcorp and running score (API?)
                        </b-card-text>
                    </b-card>

                    <b-card header="ISO">
                        <blockquote class="blockquote mb-0">
                            <p> Link to ISO (All if we go for more) with details and certificates</p>

                        </blockquote>
                    </b-card>

                    <b-card border-variant="info" header-bg-variant="transparent" class="text-center p-4">

                        <b-title><i class="fa-3x fa fa-recycle text-info"></i></b-title>
                        <b-card-text class="mt-2 mx-auto">
                            In 2023 we recycled:
                            <b-list-group>
                                <b-list-group-item class="d-flex justify-content-between align-items-center">
                                    laptops
                                    <b-badge variant="info" pill>22</b-badge>
                                </b-list-group-item>

                                <b-list-group-item class="d-flex justify-content-between align-items-center">
                                    servers
                                    <b-badge variant="info" pill>2</b-badge>
                                </b-list-group-item>

                                <b-list-group-item class="d-flex justify-content-between align-items-center">
                                    telephones
                                    <b-badge variant="info" pill>65</b-badge>
                                </b-list-group-item>
                            </b-list-group>
                            <b-card-text class="small text-muted">Saved from Landfill</b-card-text>

                        </b-card-text>
                    </b-card>

                    <b-card border-variant="warning" header=" Staff Travel Flight Emissions (tonnes)"
                        header-bg-variant="transparent" class="text-center p-4">
                        <b-title><i class="fa-3x fa fa-plane text-warning"></i></b-title>
                        <b-list-group>
                            <b-list-group-item class="d-flex justify-content-between align-items-center">
                                2020
                                <b-badge variant="primary" pill>32,512</b-badge>
                            </b-list-group-item>

                            <b-list-group-item class="d-flex justify-content-between align-items-center">
                                2021
                                <b-badge variant="primary" pill>31,555</b-badge>
                            </b-list-group-item>

                            <b-list-group-item class="d-flex justify-content-between align-items-center">
                                2022
                                <b-badge variant="primary" pill>29,000</b-badge>
                            </b-list-group-item>
                            <b-list-group-item class="d-flex justify-content-between align-items-center">
                                2023
                                <b-badge variant="primary" pill>27,000</b-badge>
                            </b-list-group-item>
                        </b-list-group>
                        <b-title><i class="fa-3x fa fa-arrow-down text-warning"></i></b-title>
                    </b-card>

                    <b-card bg-variant="dark" text-variant="white" class="round-50 text-center p-4">
                        <b-title><i class="fa-3x fa fa-tachometer"></i></b-title>
                        <b-card-text class="mt-2">
                            Staff mileage from expense forms. Monitor and reduce this?
                        </b-card-text>
                    </b-card>

                    <b-card title="Woodland trust" img-src="/img/cms/trees.jpg" img-alt="Woodland" img-top>
                        <b-card-text>
                            No of trees planted and calculation of which year and how much impact these will have on our CO2
                            impact
                        </b-card-text>
                    </b-card>

                    <b-card title="Certificates" img-src="https://picsum.photos/400/200/?image=41" img-alt="Certificates"
                        img-top>
                        <b-card-text>
                            Link of Fgas certificates for the air conditioning
                        </b-card-text>
                    </b-card>

                    <b-card title="Sustainability" img-src="/img/cms/sustainability-icons.png" img-alt="Image" img-top>
                        <b-card-text>
                            A live stat count of the energy that our solar panels are creating and what we are using?
                        </b-card-text>
                        <b-card-text class="small text-muted">Last updated 3 mins ago</b-card-text>
                    </b-card>

                    <b-card bg-variant="danger" text-variant="white" class="round-35 text-center p-4">
                        <b-title><i class="fa-3x fa fa-gbp"></i></b-title>
                        <b-card-text class="mt-2">
                            I think it could be a good idea to show the amount year on year that is put as a cost on the
                            sustainable BLAC code in &pounds;<br>
                            "Sustainablity has cost us &pounds;... this year"
                        </b-card-text>
                    </b-card>

                       <b-card header="BCorp">
                    <blockquote class="blockquote mb-0">
                        <div class="flex-margin-fix">

                            <div class="b-aspect d-flex">
                                <div class="b-aspect-sizer flex-grow-1" style="padding-bottom: 100%; height: 0px;"></div>
                                <div class="b-aspect-content flex-grow-1 w-100 mw-100" style="margin-left: -100%;">
                                    <div>
                                        <div class="embed-responsive embed-responsive-4by3"><iframe
                                                src="https://player.vimeo.com/video/651234509"
                                                allowfullscreen="allowfullscreen" class="embed-responsive-item"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sm mt-n4">
                            <p>B Corp Certification demonstrates a company's entire social and environmental impact.</p>

                            <p>B Corp Certification is a designation that a business is meeting high standards of verified
                                performance, accountability, and transparency on factors from employee benefits and
                                charitable giving to supply chain practices and input materials.</p>

                            <p class="text-right mb-4"><a href="https://www.bcorporation.net/en-us/" target="_blank">Find out more... </a> </p>
                            </div>
                    </blockquote>
                </b-card>
                  <b-card title="FuturePlus" img-src="/img/cms/futureplus.PNG" img-alt="FuturePlus" img-top>
                        <b-card-text>
                            <p>     Powered by data and guided by human expertise, FuturePlus is an award-winning sustainability management and reporting platform that empowers companies, investors, and asset managers of all sizes to understand, measure, evidence, improve, and report on their sustainability impact and goals.</p>
                       
                            <p class="text-right mb-4"><a href="https://www.future-plus.co.uk/" target="_blank">Find out more... </a> </p>
                        </b-card-text>
                    </b-card>
                      <b-card title="Azure Carbon Emissions" img-src="/img/cms/azure_carbon_emissions.PNG"
                    img-alt="Azure Carbon Emissions" img-top>
                    <b-card-text>
                        <p> Calculate your carbon emissions from cloud-based computing.</p>
                    </b-card-text>

                </b-card>

                  <b-card border-variant="info" header-bg-variant="transparent" class="text-center p-4">

                    <b-title><i class="fa-3x fa fa-trash text-info"></i></b-title>
                    <b-card-text class="mt-2 mx-auto">
                        Waste Analysis (% of waste by type)

                        <b-list-group>
                            <b-list-group-item class="d-flex justify-content-between align-items-center bg-info">
                                <b-row class="w-100pct">
                                    <b-col cols="2">YEAR</b-col>
                                    <b-col cols="3">TOTAL(kg)</b-col>
                                    <b-col cols="3">RECYCLING*</b-col>
                                    <b-col cols="2">FOOD*</b-col>
                                    <b-col cols="2">TOTAL*</b-col>
                                </b-row>
                            </b-list-group-item>

                            <b-list-group-item class="d-flex justify-content-between align-items-center">
                                <b-row class="w-100pct">
                                    <b-col cols="2" class="strong">2022</b-col>
                                    <b-col cols="3">1672</b-col>
                                    <b-col cols="3">12%</b-col>
                                    <b-col cols="2">0%</b-col>
                                    <b-col cols="2"><b-badge variant="info" pill>12%</b-badge></b-col>
                                </b-row>
                            </b-list-group-item>

                            <b-list-group-item class="d-flex justify-content-between align-items-center">
                                <b-row class="w-100pct">
                                    <b-col cols="2" class="strong">2023</b-col>
                                    <b-col cols="3">2820</b-col>
                                    <b-col cols="3">19%</b-col>
                                    <b-col cols="2">32%</b-col>
                                    <b-col cols="2"><b-badge variant="info" pill>51%</b-badge></b-col>
                                </b-row>
                            </b-list-group-item>
                        </b-list-group>
                        <b-card-text class="small text-muted">
                            Our total waste went up by 69% last year but we recycled 51% of it, 39% more than in 2022.<br>
                            Electricity usage went down by 21%<br>
                            Water was up 60% Usage & 62% Waste, so this will need looking in to.<br>
                        </b-card-text>

                    </b-card-text>
                </b-card>

                   <b-card title="Waste Analysis" img-src="/img/cms/waste.PNG" img-alt="Waste Analysis" img-top>
                    <b-card-text>
                        <p> Our total waste went up by 69% last year but we recycled 51% of it, 39% more than in 2022.<br>
                            Electricity usage went down by 21% <br>
                            Water was up 60% Usage & 62% Waste, so this will need looking in to.
                        </p>
                    </b-card-text>

                </b-card>
                     

                </b-card-group>
            </div> -->
        </b-card>

        <TileAdd />
        <TileSettings v-if="tile_selected || tile_selected == 0" :tile="defaultOptions.layout_grid[tile_selected]
            ? defaultOptions.layout_grid[tile_selected]
            : { name: 'Empty Settings', settings: [] }
            " @apply="saveTile" @cancel="tile_settings = false" />
    </b-overlay>
</template>
  
<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";


import TickChart from "../Tiles/TickChart";
import TickEmissions from "../Tiles/TickEmissions";

import CarbonEmissions from "./Carbon/CarbonEmissions";
import TPSolar from "./TPEmissions/TPSolar";
import BCorp from "./TPEmissions/BCorp";

export default {
    name: "OurEmissions",
    components: {
        BCorp,
        CarbonEmissions,
        TPSolar,
        TickChart,
        TickEmissions,
    },
    async activated() {
        console.log("dashboard is activated");
        await this.CMS();
        this.layout_refresh();
    },
    deactivated() {
        console.log("dashboard is deactivated");
        clearInterval(this.timer_time);
        clearInterval(this.timer_refresh);
    },
    data() {
        return {
            title: "Our Emissions",
            icon: "fa fa-envira text-success",
            toolbar_variant: "outline-primary",
            busy: false,
            refresh: false,
            refresh_at: 5,
            refresh_time: new Date(),
            refresh_timeago: "",
            refresh_popover: false,
            layout_grid: [],
            layout_edit: false,
            tile_selected: null,
            tile_settings: false,
            timer_time: null,
            timer_refresh: null,
            defaultOptions: {
                layout_grid: [
                    // {
                    //     moved: false,
                    //     id: "0f5085d8-b594-40f0-8e0f-642042af2ee2",
                    //     name: "TickChart",
                    //     cols: 12,
                    //     lg: 6,
                    //     settings: [
                    //         {
                    //             key: "type",
                    //             label: "Chart Type",
                    //             type: "radio-group",
                    //             buttons: true,
                    //             "button-variant": "outline-primary",
                    //             values: [{ value: "table", text: "Table" }],
                    //             value: "table",
                    //         },
                    //         {
                    //             key: "fileid",
                    //             label: "File Id",
                    //             type: "radio-group",
                    //             buttons: true,
                    //             "button-variant": "outline-primary",
                    //             values: [{ value: "navitas_log", text: "navitas_log" }],
                    //             value: "navitas_log",
                    //         },
                    //         {
                    //             key: "title",
                    //             label: "Title",
                    //             type: "radio-group",
                    //             buttons: true,
                    //             "button-variant": "outline-primary",
                    //             values: [
                    //                 { value: true, text: "On" },
                    //                 { value: false, text: "Off" },
                    //             ],
                    //             value: true,
                    //             tab: "Annotate",
                    //         },
                    //         {
                    //             key: "titletext",
                    //             label: "Title Text",
                    //             type: "text",
                    //             value: "ETRPStatus",
                    //             tab: "Annotate",
                    //         },
                    //         {
                    //             key: "legend",
                    //             label: "Legend",
                    //             type: "radio-group",
                    //             buttons: true,
                    //             "button-variant": "outline-primary",
                    //             values: [
                    //                 { value: true, text: "On" },
                    //                 { value: false, text: "Off" },
                    //             ],
                    //             value: false,
                    //             tab: "Annotate",
                    //         },
                    //         {
                    //             key: "legendposition",
                    //             label: "Legend Position",
                    //             type: "radio-group",
                    //             buttons: true,
                    //             "button-variant": "outline-primary",
                    //             values: [
                    //                 { value: "top", text: "Top" },
                    //                 { value: "bottom", text: "Bottom" },
                    //                 { value: "left", text: "Left" },
                    //                 { value: "right", text: "Right" },
                    //             ],
                    //             value: "bottom",
                    //             tab: "Annotate",
                    //         },
                    //         {
                    //             key: "datalabels",
                    //             label: "Data Labels",
                    //             type: "radio-group",
                    //             buttons: true,
                    //             "button-variant": "outline-primary",
                    //             values: [
                    //                 { value: true, text: "On" },
                    //                 { value: false, text: "Off" },
                    //             ],
                    //             value: false,
                    //             tab: "Annotate",
                    //         },

                    //         {
                    //             key: "titlefontnamesize",
                    //             label: "",
                    //             label_type: "Font Type",
                    //             label_size: "Font Size",
                    //             type: "fontsize",
                    //             values_type: [
                    //                 { value: "Arial", text: "Arial" },
                    //                 { value: "Helvetica Neue", text: "Helvetica Neue" },
                    //             ],
                    //             values_size: [
                    //                 { value: "10", text: "10" },
                    //                 { value: "12", text: "12" },
                    //                 { value: "14", text: "14" },
                    //             ],
                    //             tab: "Fonts",
                    //         },
                    //     ],
                    //     options: {
                    //         actions: [
                    //             {
                    //                 key: "settings",
                    //                 label: "Settings",
                    //                 icon: "fa fa fa-cog text-primary",
                    //             },
                    //             { divider: true },
                    //             { key: "small", label: "Small", icon: "fa fa-th text-primary" },
                    //             {
                    //                 key: "large",
                    //                 label: "Large",
                    //                 icon: "fa fa-square text-primary",
                    //             },
                    //             { divider: true },
                    //             {
                    //                 key: "delete",
                    //                 label: "Delete",
                    //                 icon: "fa fa-trash text-danger",
                    //             },
                    //         ],
                    //     },
                    // },
                    // {
                    //     moved: false,
                    //     id: "0f5085d8-b594-40f0-8e0f-642042af2ee2",
                    //     name: "TickEmissions",
                    //     cols: 12,
                    //     lg: 6,
                    //     settings: [
                    //         {
                    //             key: "type",
                    //             label: "Chart Type",
                    //             type: "radio-group",
                    //             buttons: true,
                    //             "button-variant": "outline-primary",
                    //             values: [{ value: "table", text: "Table" }],
                    //             value: "table",
                    //         },
                    //         {
                    //             key: "fileid",
                    //             label: "File Id",
                    //             type: "radio-group",
                    //             buttons: true,
                    //             "button-variant": "outline-primary",
                    //             values: [{ value: "navitas_log", text: "navitas_log" }],
                    //             value: "navitas_log",
                    //         },
                    //         {
                    //             key: "title",
                    //             label: "Title",
                    //             type: "radio-group",
                    //             buttons: true,
                    //             "button-variant": "outline-primary",
                    //             values: [
                    //                 { value: true, text: "On" },
                    //                 { value: false, text: "Off" },
                    //             ],
                    //             value: true,
                    //             tab: "Annotate",
                    //         },
                    //         {
                    //             key: "titletext",
                    //             label: "Title Text",
                    //             type: "text",
                    //             value: "ETRPStatus",
                    //             tab: "Annotate",
                    //         },
                    //         {
                    //             key: "legend",
                    //             label: "Legend",
                    //             type: "radio-group",
                    //             buttons: true,
                    //             "button-variant": "outline-primary",
                    //             values: [
                    //                 { value: true, text: "On" },
                    //                 { value: false, text: "Off" },
                    //             ],
                    //             value: false,
                    //             tab: "Annotate",
                    //         },
                    //         {
                    //             key: "legendposition",
                    //             label: "Legend Position",
                    //             type: "radio-group",
                    //             buttons: true,
                    //             "button-variant": "outline-primary",
                    //             values: [
                    //                 { value: "top", text: "Top" },
                    //                 { value: "bottom", text: "Bottom" },
                    //                 { value: "left", text: "Left" },
                    //                 { value: "right", text: "Right" },
                    //             ],
                    //             value: "bottom",
                    //             tab: "Annotate",
                    //         },
                    //         {
                    //             key: "datalabels",
                    //             label: "Data Labels",
                    //             type: "radio-group",
                    //             buttons: true,
                    //             "button-variant": "outline-primary",
                    //             values: [
                    //                 { value: true, text: "On" },
                    //                 { value: false, text: "Off" },
                    //             ],
                    //             value: false,
                    //             tab: "Annotate",
                    //         },

                    //         {
                    //             key: "titlefontnamesize",
                    //             label: "",
                    //             label_type: "Font Type",
                    //             label_size: "Font Size",
                    //             type: "fontsize",
                    //             values_type: [
                    //                 { value: "Arial", text: "Arial" },
                    //                 { value: "Helvetica Neue", text: "Helvetica Neue" },
                    //             ],
                    //             values_size: [
                    //                 { value: "10", text: "10" },
                    //                 { value: "12", text: "12" },
                    //                 { value: "14", text: "14" },
                    //             ],
                    //             tab: "Fonts",
                    //         },
                    //     ],
                    //     options: {
                    //         actions: [
                    //             {
                    //                 key: "settings",
                    //                 label: "Settings",
                    //                 icon: "fa fa fa-cog text-primary",
                    //             },
                    //             { divider: true },
                    //             { key: "small", label: "Small", icon: "fa fa-th text-primary" },
                    //             {
                    //                 key: "large",
                    //                 label: "Large",
                    //                 icon: "fa fa-square text-primary",
                    //             },
                    //             { divider: true },
                    //             {
                    //                 key: "delete",
                    //                 label: "Delete",
                    //                 icon: "fa fa-trash text-danger",
                    //             },
                    //         ],
                    //     },
                    // },
                ],
            },
            selectedComponent: null,
            search: {
                slac: 'STAFFTRAV',
                event: null,
                event_name: "",
                date: null,
            },
        };
    },
    watch: {
        refresh: {
            // immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    this.refresh_time = new Date();
                }
            },
        },
    },
    computed: {
        ...mapGetters(["window", "user"]),
    },
    methods: {
        async loadData() {
            console.log("loadData");
            this.busy = true;

            // OVERIDE THE DATA
            this.layout_grid = this.defaultOptions.layout_grid;

            this.busy = false;
            this.layout_autorefresh();
        },
        async saveData() {
            console.log("saveData", this.layout);
            this.busy = true;
            
            this.busy = false;
            this.layout_edit = false;
        },
        async saveTile(t) {
            console.log("saveTile", this.tile_selected, t);
            this.layout_grid[this.tile_selected] = t;
            this.refresh = true;
            this.tile_settings = false;
        },
        invoke_action(s, r) {
            console.log("invoke action", s, r);
            if (s.key) {
                console.log(s.key);
                switch (s.key) {
                    case "settings":
                        this.tile_settings = true;
                        this.$root.$emit("bv::toggle::collapse", "tilesettings");
                        break;
                }
            }
        },
        async layout_refresh() {
            this.refresh = true;
            await this.loadData();
        },
        layout_autorefresh() {
            this.refresh_time = new Date();
            this.refresh = true;
            clearInterval(this.timer_time);
            clearInterval(this.timer_refresh);
            if (this.refresh_at > 0) {
                this.timer_refresh = setInterval(() => {
                    this.layout_autorefresh();
                }, 100000);
                if (this.refresh_at > 0) {
                    this.timer_time = setInterval(() => {
                        this.layout_timeago();
                    }, 10000);
                }
                this.layout_timeago();
            }
            console.log("layout_autorefresh");
        },
        layout_timeago() {
            this.refresh_timeago = this.$options.filters.formatTimeago(
                this.refresh_time
            );
            console.log("layout_timeago");
        },
        runreport(e, c) {
            console.log("run", e);
            if (c) {
                this.selectedComponent = c;
            } else {
                this.selectedComponent = "Report";
            }
            this.search = {
                name: e.label,
                call: e.id,
            };
        },
    },
};
</script>
  
<style></style>
  